import React from 'react'

const VissionMisson = () => {
    return (
        <section className='bg-light'>
            <div className='container'>
                <div className='row py-4'>

                    <div className='col-sm-6 my-2'>

                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">Our <span className='col_1'>Vision</span></h5>

                                <p className="card-text" style={{textAlign:"justify"}}>We strive to uphold growth and fulfil our customer requirement and needs by embracing energy conservation practices and safety policies that align with international standards.</p>

                            </div>
                        </div>

                    </div>
                    <div className='col-sm-6 my-2'>
                        <div className="card h-100 " >
                            <div className="card-body ">
                                <h5 className="card-title">Our <span className='col_1'>Mission</span></h5>

                                <p className="card-text" style={{textAlign:"justify"}}>We Deliver innovative solutions for energy conservation, ensuring profitability and sustainability for the benefit of all customer. Enthusiastically champion customer centric initiatives with a clear sense of purpose.</p>

                            </div>
                        </div>

                    </div>
                </div>


            </div>

        </section>
    )
}

export default VissionMisson